import CarouselHandler from './carousel-handler'

export default CarouselHandler
